
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "@/components/Sidebar";
import Header from "@/components/Header";
import BottomNav from "@/components/BottomNav";
import FloatingHelpButton from "@/components/FloatingHelpButton";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";

const LearnerLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [showBackButton, setShowBackButton] = useState(false);

  useEffect(() => {
    const nonHomeRoutes = ['/learn', '/play', '/leaderboards', '/invest', '/save', '/track', '/community', '/profile'];
    setShowBackButton(nonHomeRoutes.includes(location.pathname));
  }, [location]);

  const handleBack = () => {
    navigate('/home');
  };

  return (
    <div className="flex min-h-screen w-full overflow-x-hidden bg-background">
      {/* Sidebar with smooth transition */}
      <Sidebar 
        isOpen={isSidebarOpen} 
        onOpenChange={setIsSidebarOpen}
      />
      
      {/* Header with consistent height */}
      <Header onMenuClick={() => setIsSidebarOpen(true)} />
      
      <div className="flex flex-col flex-1 w-full min-h-screen md:ml-64">
        <main className="flex-1 w-full px-3 sm:px-4 pb-20 md:pb-8 md:p-8 mt-14 md:mt-0 transition-all duration-300 ease-in-out bg-background">
          {showBackButton && (
            <Button
              variant="ghost"
              onClick={handleBack}
              className="mb-3 sm:mb-4 -ml-2 group hover:bg-transparent p-0"
            >
              <ArrowLeft className="h-4 w-4 sm:h-5 sm:w-5 mr-1.5 sm:mr-2 transition-transform group-hover:-translate-x-1" />
              <span className="text-sm sm:text-base">Back to Dashboard</span>
            </Button>
          )}
          <div className="animate-fade-in">
            <Outlet />
          </div>
        </main>
      </div>

      {/* Floating Help Button - positioned fixed on the page */}
      <FloatingHelpButton />

      <BottomNav />
    </div>
  );
};

export default LearnerLayout;
